import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

export default function JudgeTools() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 gap-6">
      <Link to="/" className="text-gray-600 text-sm mb-4 no-underline hover:text-gray-400">← Back</Link>

      <div className="text-center mb-2">
        <img src={logo} alt="" className="w-full max-w-xs mx-auto" />
        <div className="flex items-center gap-3 max-w-[280px] mx-auto mt-2 mb-3">
          <div className="flex-1 h-px bg-dark-500" />
          <span className="text-gray-400 text-[10px] font-display font-bold tracking-[0.25em] whitespace-nowrap">
            STUDY &bull; FENCE &bull; GROW
          </span>
          <div className="flex-1 h-px bg-dark-500" />
        </div>
        <h1 className="font-display text-2xl font-bold">Judge Tools</h1>
        <p className="text-gray-500 text-sm mt-1">Score bouts with the Technical Ruleset</p>
      </div>

      <div className="w-full max-w-xs flex flex-col gap-3">
        <Link to="/bout/join"
          className="block w-full p-5 bg-gradient-to-br from-green-action-light to-green-action rounded-xl text-center no-underline hover:opacity-90 transition-opacity">
          <div className="font-display text-lg font-bold text-white tracking-wide">Join a Bout</div>
        <div className="text-green-action-text text-xs mt-1">Enter the shared official bout code</div>
        </Link>

        <Link to="/judge/standalone"
          className="block w-full p-5 bg-dark-700 border border-dark-500 rounded-xl text-center no-underline hover:border-gray-600 transition-colors">
          <div className="font-display text-lg font-bold text-white tracking-wide">Use Standalone</div>
          <div className="text-gray-500 text-xs mt-1">Score on your own — no event connection needed</div>
        </Link>
      </div>
    </div>
  );
}
